function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.20674 9.56084H8.34865C8.58545 9.56084 8.78182 9.36251 8.78182 9.12334C8.78182 8.88418 8.58545 8.69168 8.34865 8.69168H5.20674C4.96994 8.69168 4.77357 8.88418 4.77357 9.12334C4.77357 9.36251 4.96994 9.56084 5.20674 9.56084ZM7.15889 5.77501H5.20674C4.96994 5.77501 4.77357 5.97334 4.77357 6.21251C4.77357 6.45168 4.96994 6.64418 5.20674 6.64418H7.15889C7.39568 6.64418 7.59205 6.45168 7.59205 6.21251C7.59205 5.97334 7.39568 5.77501 7.15889 5.77501ZM11.2806 5.26496C11.4164 5.26339 11.5642 5.26169 11.6985 5.26169C11.8429 5.26169 11.9584 5.37835 11.9584 5.52419V10.2142C11.9584 11.6609 10.7975 12.8334 9.36518 12.8334H4.76782C3.26617 12.8334 2.04175 11.6025 2.04175 10.0859V3.79752C2.04175 2.35085 3.20841 1.16669 4.64653 1.16669H7.73069C7.88086 1.16669 7.99637 1.28919 7.99637 1.43502V3.31335C7.99637 4.38085 8.86848 5.25585 9.92541 5.26169C10.1723 5.26169 10.3899 5.26353 10.5804 5.26515C10.7286 5.2664 10.8603 5.26752 10.9766 5.26752C11.0588 5.26752 11.1654 5.26629 11.2806 5.26496ZM11.4399 4.41352C10.9652 4.41527 10.4055 4.41352 10.0029 4.40943C9.36416 4.40943 8.83801 3.87802 8.83801 3.23285V1.69518C8.83801 1.44377 9.14007 1.31893 9.31276 1.50035L11.638 3.94277C11.8067 4.11952 11.6831 4.41293 11.4399 4.41352Z",
  fill: "#AFAFAF"
});
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.33340b4a6d10a6aef202e3d33060ca25.svg";
export { ForwardRef as ReactComponent };